module.exports = __webpack_public_path__ + "img/arrow-2.1f3de803.svg";